<div class="page">
  <div class="subheader">
    <i class="subicon icon-angle-double-left" (click)="order.closeSidebar()"></i>
    <i class="usericon icon-ad_units-F"></i
    ><span>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PagerFastaccess.TitleHeader" | translate }} </span>
  </div>
  <div class="searchbox">
    <div class="search">
      <ssg-input
        name="inputPager"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PagerFastaccess.InputPager' | translate"
        disabled="true"
        [group]="group"
        textType="number">
        <i class="fas fa-search"></i>
      </ssg-input>
    </div>
  </div>
  <div class="button">
    <div class="d-flex">
      <ssg-button class="number" (click)="SetInputPager(1)" label="1"></ssg-button>
      <ssg-button class="number" (click)="SetInputPager(2)" label="2"></ssg-button>
      <ssg-button class="number" (click)="SetInputPager(3)" label="3"></ssg-button>
    </div>
    <div class="d-flex">
      <ssg-button class="number" (click)="SetInputPager(4)" label="4"></ssg-button>
      <ssg-button class="number" (click)="SetInputPager(5)" label="5"></ssg-button>
      <ssg-button class="number" (click)="SetInputPager(6)" label="6"></ssg-button>
    </div>
    <div class="d-flex">
      <ssg-button class="number" (click)="SetInputPager(7)" label="7"></ssg-button>
      <ssg-button class="number" (click)="SetInputPager(8)" label="8"></ssg-button>
      <ssg-button class="number" (click)="SetInputPager(9)" label="9"></ssg-button>
    </div>
    <div class="d-flex">
      <ssg-button class="number rotateicon arrowleftSize" (click)="BackSpaceInputPager()" icon="icon-long-arrow-left"></ssg-button>
      <ssg-button class="number ziro" (click)="SetInputPager(0)" label="0"></ssg-button>
      <ssg-button class="number" (click)="ClearInputPager()" label="C"></ssg-button>
    </div>
  </div>
  <div class="logingroup">
    <div class="loginbutton">
      <ssg-button
        *ngIf="!(invoiceservice.order?.saleMethodBranch?.ShowDescInvKitchen || invoiceservice.order?.saleMethodBranch?.ShowDescInvCustomer)"
        icon="icon-insert"
        class="login"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PagerFastaccess.SetPager' | translate"
        buttontype="submit"
        size="larg"
        (click)="SetInvoicePager()"
        appearance="flat"></ssg-button>
      <ssg-button
        *ngIf="invoiceservice.order?.saleMethodBranch?.ShowDescInvKitchen || invoiceservice.order?.saleMethodBranch?.ShowDescInvCustomer"
        icon="icon-insert"
        class="login"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PagerFastaccess.SetPager' | translate"
        buttontype="submit"
        size="larg"
        (click)="SetInvoicePagerDestCustomerKitchen()"
        appearance="flat"></ssg-button>
    </div>
  </div>
</div>
